<template>
  <div>
    <div class="container-logger">
      <div class="col col-left">
        <img
          class="logger-image"
          :src="leftImage"
        >
        <span>{{ detail.leftName }}</span>
      </div>
      <div class="col col-right">
        <span>{{ detail.rightName }}</span>
        <img
          class="logger-image"
          :src="rightImage"
        >
      </div>
    </div>
    <div class="container-pipe">
      <div class="p-col col-center">
        <ul class="section-list">
          <li
            v-for="pipe in pipes"
            :key="pipe.id"
            :style="{ width: pipe.percentage + '%' }"
            :title="pipe.length + ' ' + pipe.abrev"
          />
        </ul>
      </div>
    </div>
    <div class="container-distance">
      <div
        :id="'pointerContainer' + id"
        class="distance-section pointer-container"
      >
        <div
          :id="'pointerPipe' + id"
          class="pipe-pointer"
          :style="{ left: leftPercentage }"
        />
      </div>
      <div class="distance-section">
        <div class="col-arrow arrow-left" />
        <div class="col-line">
          <hr>
        </div>
        <div class="col-arrow arrow-right" />
      </div>
      <div class="distance-section">
        <div class="distance-container">
          <span
            v-if="showOutOfBracket"
            class="out-of-bracket left"
          >{{ strings.outOfBracket}}
          </span>
          <span
            v-if="!showOutOfBracket"
            :id="'displayLeft' + id"
            class="left"
          >
            {{ displayLeft }}
          </span>
        </div>
        <div class="distance-container">
          <span
            v-if="!showOutOfBracket"
            :id="'displayRight' + id"
            class="right"
          >
            {{ displayRight }}
          </span>
          <span
            v-if="showOutOfBracket"
            class="out-of-bracket right"
          >
            {{ strings.outOfBracket }}
          </span>
        </div>
      </div>
      <div class="distance-section">
        <div class="col-arrow arrow-left" />
        <div class="col-line">
          <hr>
        </div>
        <div class="col-arrow arrow-right" />
      </div>
      <div class="distance-section total">
       {{ strings.totalPipeLength }} = <span>{{ detail.pipeLength }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "PipeDiagram",
  props: {
    detail: {
      type: Object,
      default: null
    },
    id: {
      type: String,
      default: ""
    },
    peakMS: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      oldValue: 0
    };
  },
  computed: {
    ...mapGetters("page", ["contentUrl", "strings"]),
    pipes() {
      if (this.detail && this.detail.pipes) {
        let pipeLength = this.detail.pipeLength;
        let pipeDetails = [];
        this.detail.pipes.forEach(pipe => {
          let pipeObj = {
            id: pipe.id,
            length: pipe.length,
            abrev: "",
            pixels: pipe.pixels,
            velocity: pipe.velocity
          };
          pipeObj.percentage = this.getPercentage(
            pipeObj.length,
            pipeLength
          ).toFixed(2);
          pipeDetails.push(pipeObj);
        });
        return pipeDetails;
      } else {
        return null;
      }
    },
    showOutOfBracket() {
      if (this.detail && this.dynamicLeft && this.dynamicLeft) {
        if (
          parseInt(this.dynamicLeft) <= 0 ||
          parseInt(this.dynamicLeft) >= parseInt(this.detail.pipeLength)
        ) {
          return true;
        }
        return false;
      }
      return false;
    },
    dynamicLeft() {
      return this.detail.distance;
      let times = [];
      let timeMax = 0;
      let peakMsCopy = this.peakMS;
      let totalLength = this.detail.pipeLength;

      //Calculate the times it would take for a sound starting at the LH end to get to the RH end of each pipe segment.
      this.pipes.forEach(pipe => {
        let time = (pipe.length / pipe.velocity) * 1000;
        timeMax += time;
        times.push(timeMax);
      });

      //Calculate the time which the leak sound takes to reach the LH sensor, shown as timeToLeak:
      let timeToLeak = (this.peakMS + timeMax) / 2;

      // if timeToLeak is greater the the max, then return the piplength + 1 to force out of bracket
      if (timeToLeak > timeMax) {
        return parseInt(totalLength, 10) + 1;
      }

      //Starting from the LH end, find which pipe segment the leak occurs in.
      //This is found by stepping along the pipe segments, and taking the time range for each segment(0 to T1, T1 to T2, T2 to T3 etc).
      //Stop when the start and end times for the segment bracket the value of timeToLeak.NB we start at the LH end, so T0 is 0.
      //Call the index of this segment "segmentWithCorrelation".The time range of this segment is Tk to T[k + 1].
      let segmentWithCorrelation = 0;
      let timeValue = 0;
      for (let i = 0; i < this.pipes.length; i++) {
        let length = this.pipes[i].length;
        let velocity = this.pipes[i].velocity;
        let time = (length / velocity) * 1000;
        timeValue += time;
        if (timeToLeak < timeValue) {
          segmentWithCorrelation = i;
          break;
        }
      }

      //Step along the pipe model computing the distance to the start of each pipe segment, up to the start of the segment in which the leak occurs:
      //L0 = 0
      //L1 = L0 + D0
      //L2 = L1 + D1
      //…
      //Lk = L[k - 1] + D[k - 1]
      let distanceToSection = 0;
      for (let i = 0; i < segmentWithCorrelation; i++) {
        distanceToSection += this.pipes[i].length;
      }

      //if on the first section, to get the leak position use L = (D – (V * Td)) / 2
      //D Total pipe length
      //V Velocity
      //Td peakMS (peak)
      if (distanceToSection === 0) {
        let total = parseFloat(totalLength);
        velocity = this.pipes[0].velocity;
        if (peakMsCopy > 0) {
          return (total - velocity * ((peakMsCopy *= -1) / 1000)) / 2;
        } else {
          return (total - velocity * (Math.abs(peakMsCopy) / 1000)) / 2;
        }
      }

      //The leak position L is equal to the distance to the start of the pipe segment k, plus the distance along that segment.
      //The distance along the segment comes from the time along that segment multiplied by the velocity for that segment.Hence:
      //L = Lk + ((timeToLeak – Tk) * Vk)
      let velocity = this.pipes[segmentWithCorrelation].velocity;
      let tk = times[segmentWithCorrelation - 1] / 1000;
      timeToLeak /= 1000;
      return distanceToSection + (timeToLeak - tk) * velocity;
    },
    dynamicRight() {
      return this.detail.pipeLength - this.dynamicLeft;
    },
    displayLeft() {
      return this.dynamicLeft.toFixed(2);
    },
    displayRight() {
      return this.dynamicRight.toFixed(2);
    },
    leftPercentage() {
      if (this.detail && this.detail.pipeLength && this.dynamicLeft) {
        let percentage = (this.dynamicLeft / this.detail.pipeLength) * 100;
        if (percentage >= 0) return percentage.toFixed(2) + "%";
        else if (percentage >= 100) return "100%";
        else return "0%";
      } else {
        return "0%";
      }
    },
    leftImage() {
      return `${this.contentUrl}/icons/logger-sm-left.png`;
    },
    rightImage() {
      return `${this.contentUrl}/icons/logger-sm-right.png`;
    }
  },
  methods: {
    getPercentage(a, b) {
      return (a / b) * 100;
    }
  }
};
</script>

<style scoped>
/*Logger container
------------------------------------*/
.container-logger {
  display: flex;
  -ms-flex-flow: row nowrap;
  -webkit-flex-flow: row nowrap;
  flex-flow: row nowrap;
  text-transform: uppercase;
  font-size: 11px;
  line-height: 11px;
  padding: 10px 20px 15px 20px;
}
.container-logger .col.col-left {
  width: 50%;
  text-align: left;
}
.container-logger .col.col-right {
  width: 50%;
  text-align: right;
}
.logger-image {
  width: 12;
  height: 16;
}
.container-logger span {
  position: relative;
  top: -4px;
  padding-left: 5px;
  padding-right: 5px;
}
/*Pipe container
------------------------------------*/
.container-pipe {
  display: flex;
  -ms-flex-flow: row nowrap;
  -webkit-flex-flow: row nowrap;
  flex-flow: row nowrap;
  height: 22px;
}
.p-col {
  -ms-flex-positive: 1;
  -webkit-box-flex: 1;
  flex-grow: 1;
  max-width: 100%;
}
.container-pipe .p-col.col-left,
.container-pipe .p-col.col-right {
  height: 20px;
  background-image: url("https://atriumiot.com/content/icons/pipe-model-grey.png");
  background-repeat: repeat-x;
}
.container-pipe .p-col.col-left {
  width: 38px;
}
.container-pipe .p-col.col-right {
  width: 39px;
}
.container-pipe .p-col.col-center {
  height: 20px;
  width: 100%;
  background-image: url("https://atriumiot.com/content/icons/pipe-model-blue.png");
  background-repeat: repeat-x;
}
.section-list {
  list-style-type: none;
}
.container-pipe .p-col.col-center ul {
  height: 20px;
  margin: 0;
  padding: 0;
  overflow: hidden;
}
.container-pipe .p-col.col-center ul li {
  margin: 0;
  padding: 2px 0 0 0;
  float: left;
  text-align: center;
  font-size: 11px;
  letter-spacing: 1.5px;
  border: 1px solid #000;
  height: 20px;
}
/*Distance container
------------------------------------*/
container-distance {
  position: relative;
  top: -15px;
  padding: 0 35px 0 34px;
}
.container-distance .distance-section {
  display: flex;
  -ms-flex-flow: row nowrap;
  -webkit-flex-flow: row nowrap;
  flex-flow: row nowrap;
}
.container-distance .pointer-container {
  margin-left: 6px;
  margin-right: 6px;
}
.container-distance .distance-container {
  width: 50%;
  font-size: 11px;
  line-height: 11px;
  letter-spacing: 1.5px;
  font-weight: 500;
}
.container-distance .distance-container span {
  position: relative;
  left: 0;
}
.container-distance .distance-container span.out-of-bracket {
  left: 0;
}
/* .container-distance .distance-container span.out-of-bracket.right {
  left: 350px;
} */
.container-distance .distance-section .col-arrow {
  width: 8px;
  height: 14px;
}
.container-distance .distance-section .col-arrow.arrow-left {
  background-image: url("https://atriumiot.com/content/icons/arrow-sm-left.png");
  background-repeat: no-repeat;
  border-left: 1px solid #000;
}
.container-distance .distance-section .col-arrow.arrow-right {
  background-image: url("https://atriumiot.com/content/icons/arrow-sm-right.png");
  background-repeat: no-repeat;
  border-right: 1px solid #000;
}
.col-arrow i {
  width: 10px;
  padding: 0;
  margin: 0;
  display: none;
}
.arrows {
  margin-left: 35px;
  margin-right: 35px;
}
.container-distance .distance-section .col-line {
  width: 100%;
}
.container-distance .distance-section .col-line hr {
  color: #000;
  background: #000;
  height: 1px;
  margin: 0;
  padding: 0;
  margin-top: 5px;
}
.distance-section.total {
  width: 100%;
  text-transform: uppercase;
  font-size: 11px;
  letter-spacing: 1.5px;
  align-items: center;
  justify-content: center;
  position: relative;
  top: 2px;
  font-weight: 500;
}
.distance-section.total span {
  font-weight: bold;
  display: inline-block;
  padding-left: 4px;
  text-transform: lowercase;
}
.pipe-pointer {
  width: 13px;
  height: 21px;
  background-image: url("https://atriumiot.com/content/icons/pipe-pointer.png");
  background-repeat: no-repeat;
  position: relative;
  top: 13px;
  margin-left: -6px;
}
</style>
